import React from 'react';
import { Zap, TrendingUp } from 'lucide-react';

function StatusBox({ label, value, color, icon }) {
  const colors = {
    blue: 'text-blue-400', green: 'text-green-400', yellow: 'text-yellow-400',
    red: 'text-red-400', orange: 'text-orange-400', cyan: 'text-cyan-400',
    purple: 'text-purple-400', gray: 'text-gray-400'
  };
  return (
    <div className="bg-gray-800/50 rounded-lg px-3 py-2">
      <div className="text-gray-400 text-xs mb-1">{label}</div>
      <div className={`font-bold flex items-center justify-center gap-1 ${colors[color]}`}>
        {icon}{value}
      </div>
    </div>
  );
}

export default function SystemStatusBar({ systemHealth, isRunning, speed, successRate, activeScraperInfo, celeryWorkers }) {
  const onlineCount = celeryWorkers.filter(w => w.online).length;

  return (
    <div className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border border-cyan-500/20 rounded-xl px-4 py-3 mb-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-9 gap-3 text-center">
        <StatusBox label="CPU" value={`${systemHealth.cpu}%`} color="blue" />
        <StatusBox label="RAM" value={`${systemHealth.memory}%`} color={systemHealth.memory > 80 ? 'red' : systemHealth.memory > 60 ? 'yellow' : 'green'} />
        <StatusBox label="Load" value={systemHealth.load || 0} color="purple" />
        <StatusBox label="Chrome" value={systemHealth.chrome || 0} color="cyan" />
        <StatusBox label="Disk" value={`${systemHealth.disk}%`} color="orange" />
        <StatusBox label="Speed" value={`${speed}/m`} color="yellow" icon={<Zap className="w-3 h-3" />} />
        <StatusBox label="Success" value={`${successRate}%`} color="green" icon={<TrendingUp className="w-3 h-3" />} />
        <div className="rounded-lg px-3 py-2 bg-indigo-600/20 border border-indigo-500/30">
          <div className="text-gray-400 text-xs mb-1">Workers</div>
          <div className="font-bold text-sm text-indigo-400">
            {onlineCount}/{celeryWorkers.length}
          </div>
        </div>
        <div className={`rounded-lg px-3 py-2 ${isRunning ? 'bg-green-600/20 border border-green-500/50' : 'bg-gray-800/50'}`}>
          <div className="text-gray-400 text-xs mb-1">Status</div>
          <div className={`font-bold text-sm flex items-center justify-center gap-2 ${isRunning ? 'text-green-400' : 'text-gray-400'}`}>
            <div className={`w-2 h-2 rounded-full ${isRunning ? 'bg-green-400 animate-pulse' : 'bg-gray-600'}`}></div>
            {isRunning ? 'LIVE' : 'PAUSED'}
          </div>
        </div>
      </div>
    </div>
  );
}
